import React from 'react'
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Divider
} from '@mui/material'
import { Delete as DeleteIcon } from '@mui/icons-material'
import {
  HeroSectionForm,
  FeaturesSectionForm,
  ExploreContentSectionForm,
  ProductBannersSectionForm
} from '../section-forms'
import { useStyles } from './style'

const SectionEditor = ({ section, onSectionChange, onSectionDelete, isEdit }) => {
  const classes = useStyles()

  if (!section) {
    return (
      <Box className={classes.emptyState}>
        <Typography variant='h6' color='textSecondary' align='center'>
          Select a section from the left panel to edit
        </Typography>
        <Typography variant='body2' color='textSecondary' align='center' className={classes.emptyStateSubtitle}>
          Choose from Hero, Featured Products, Explore Content, or Product Banners
        </Typography>
      </Box>
    )
  }

  const getSectionTitle = () => {
    const titles = {
      mtBanner: 'Hero Section',
      featuresBanner: 'Featured Products',
      contentExplorer: 'Explore Content Carousel',
      featureCard: 'Product Banners'
    }
    const baseTitle = titles[section.type] || section.type
    return section.instanceId ? `${baseTitle} #${section.instanceId}` : baseTitle
  }

  const renderSectionForm = () => {
    switch (section.type) {
      case 'mtBanner':
        return (
          <HeroSectionForm
            section={section}
            onChange={onSectionChange}
            isEdit={isEdit}
          />
        )
      case 'featuresBanner':
        return (
          <FeaturesSectionForm
            section={section}
            onChange={onSectionChange}
            isEdit={isEdit}
          />
        )
      case 'contentExplorer':
        return (
          <ExploreContentSectionForm
            section={section}
            onChange={onSectionChange}
            isEdit={isEdit}
          />
        )
      case 'featureCard':
        return (
          <ProductBannersSectionForm
            section={section}
            onChange={onSectionChange}
            isEdit={isEdit}
          />
        )
      default:
        return (
          <Typography color='error'>
            Unknown section type: {section.type}
          </Typography>
        )
    }
  }

  return (
    <Box className={classes.container}>
      <Paper className={classes.header} elevation={0}>
        <Box className={classes.headerContent}>
          <Box className={classes.titleSection}>
            <Typography variant='h6' className={classes.title}>
              {getSectionTitle()}
            </Typography>
          </Box>
          {isEdit && (
            <IconButton
              size='small'
              onClick={() => onSectionDelete(section.order)}
              className={classes.deleteButton}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </Box>
      </Paper>

      <Divider />

      <Box className={classes.formContainer}>
        {renderSectionForm()}
      </Box>
    </Box>
  )
}

export default SectionEditor
